<script setup lang="ts">
import {DotLottieVue} from "@lottiefiles/dotlottie-vue";
import {computed} from "vue";
import MarkdownView from "@/core/components/markdown/Markdown.vue";
import {Advantage} from "@/advantage/interfaces/Advantages";

const props = defineProps<{
    advantages: Advantage[]
}>();

const headline = computed(() => {
    if ((props.advantages.length ?? 0) > 1) {
        return 'Vos partenaires ont un cadeau pour vous !';
    }

    return 'Votre partenaire a un cadeau pour vous !';
});

</script>

<template>
  <div v-if="advantages.length" class="bg-secondary-lightest p-4 flex flex-col mt-6 gap-4">
    <div class="flex relative pr-20 sm:pr-24 md:pr-28">
      <h2 class="text-black">
        {{ headline }}
      </h2>
      <DotLottieVue
        src="animations/gift.lottie"
        class="h-20 w-20 sm:h-24 sm:w-24 md:h-28 md:w-28 absolute top-1/2 right-0 -translate-y-1/2"
        autoplay loop
      />
    </div>
    <div v-if="advantages.length">
      <div v-for="advantage in advantages" :key="advantage.id" class="flex gap-4 pb-2">
        <img v-if="advantage.logo" :src="advantage.logo" :alt="advantage.title" class="object-contain w-32 max-h-20">
        <div>
          <MarkdownView :content="advantage.sales_pitch" />
        </div>
      </div>
    </div>
  </div>
</template>
